var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectedRinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 6,
    fill: "#47C41B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5C13.9178 7.5 12.371 7.96919 11.0554 8.84824C9.73985 9.72729 8.71447 10.9767 8.10897 12.4385C7.50347 13.9003 7.34504 15.5089 7.65372 17.0607C7.9624 18.6126 8.72433 20.038 9.84315 21.1569C10.962 22.2757 12.3874 23.0376 13.9393 23.3463C15.4911 23.655 17.0997 23.4965 18.5615 22.891C20.0233 22.2855 21.2727 21.2602 22.1518 19.9446C23.0308 18.629 23.5 17.0822 23.5 15.5C23.4975 13.379 22.6538 11.3457 21.1541 9.84591C19.6543 8.34616 17.621 7.5025 15.5 7.5ZM15.5 22.0455C14.2054 22.0455 12.9399 21.6616 11.8635 20.9423C10.7871 20.2231 9.9482 19.2009 9.45279 18.0048C8.95738 16.8088 8.82776 15.4927 9.08032 14.223C9.33288 12.9534 9.95627 11.7871 10.8717 10.8717C11.7871 9.95627 12.9534 9.33287 14.223 9.08031C15.4927 8.82776 16.8088 8.95738 18.0048 9.45279C19.2009 9.9482 20.2231 10.7871 20.9423 11.8635C21.6616 12.9399 22.0455 14.2054 22.0455 15.5C22.0435 17.2354 21.3533 18.8991 20.1262 20.1262C18.8991 21.3533 17.2354 22.0435 15.5 22.0455Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6448 13.1458L14.7946 16.6753L13.1051 14.9858C13.038 14.9164 12.9578 14.861 12.8691 14.8228C12.7803 14.7847 12.6849 14.7647 12.5883 14.7638C12.4918 14.763 12.396 14.7814 12.3066 14.818C12.2172 14.8545 12.136 14.9085 12.0677 14.9768C11.9995 15.0451 11.9455 15.1263 11.9089 15.2157C11.8723 15.3051 11.8539 15.4008 11.8548 15.4974C11.8556 15.594 11.8757 15.6894 11.9138 15.7781C11.9519 15.8668 12.0073 15.9471 12.0768 16.0142L14.2586 18.196C14.3911 18.3286 14.5697 18.4048 14.7571 18.4089C14.9445 18.413 15.1262 18.3445 15.2644 18.2178L19.628 14.2178C19.7702 14.0874 19.8547 13.9059 19.863 13.7132C19.8714 13.5205 19.8028 13.3323 19.6724 13.1902C19.542 13.048 19.3605 12.9635 19.1678 12.9552C18.975 12.9469 18.7869 13.0154 18.6448 13.1458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedRinsIcon);
export default __webpack_public_path__ + "static/media/connected_rins_icon.e6c6dad318b065624641bad8da5dbb32.svg";
export { ForwardRef as ReactComponent };